interface SkeletonProps {
  height?: string
  width?: string
  borderRadius?: string
  count?: number
}

export default function Skeleton({
  height = '1rem',
  width = '100%',
  borderRadius = '4px',
  count = 1,
}: SkeletonProps) {
  return (
    <>
      {Array.from({ length: count }).map((_, idx) => (
        <div
          key={idx}
          style={{
            height,
            width,
            borderRadius,
            background: 'linear-gradient(90deg,#eee 25%,#ddd 40%,#eee 100%)',
            marginBottom: '0.5rem',
            animation: 'skeleton-loading 1.2s infinite linear',
          }}
        />
      ))}
      <style jsx>{`
        @keyframes skeleton-loading {
          0% {
            background-position: -200px 0;
          }
          100% {
            background-position: calc(200px + 100%) 0;
          }
        }
      `}</style>
    </>
  )
}
